import React, { Component } from 'react';
import {Row , Col, Button, Table, FormControl, Pagination} from 'react-bootstrap';
import Picky from 'react-picky';
import 'react-picky/dist/picky.css';
import _ from 'lodash';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
function searchingFor(filterRows){
	return function(x){
      let key = _.keys(filterRows)
      let newObj =[]
      if(!_.isEmpty(key)){        
       _.map(key, (gg) =>{  
         let val = _.get(x, gg)
        if(!_.isNull(val)){
          if(typeof val === "string"){
            newObj.push(val.toLowerCase().includes(filterRows[gg].toLowerCase()))
          } else {
            newObj.push(val.toString().includes(filterRows[gg].toString()))
          }
        }
      })
    }
    if(!_.isEmpty(newObj)){
      return !_.includes(newObj, false)
    } else {
       return true
    }
  }
}
export default class Calibration extends Component {
  constructor(props){
    super(props)
    this.state= this.getInitialState()
    this.bulkclientName=[]
  }
  getInitialState = () =>{
    return {
      selectedregionName:[],
      selectedcenterName:[],
      selectedclientName:[],
      selectedprocessName:[],
      saveClicked:false,
      activePage:1,
      assignData:[],
      filterRows:{},
      showFilter:false,
      search:false,
      selectedAuditor:[],
      startDate:'',
      endDate:''
    }
  }
  componentWillMount = () => {  
    const{inventory} = this.props;
    if(!_.isEmpty(inventory)){      
      let regionNames = _.filter(inventory);
      this.setState({selectedregionName:regionNames[0]})
      }    
  }
  componentWillReceiveProps(nextProps){
    // if(this.state.search === true && this.state.saveClicked === true){  
    //   let index = this.props.searchData.length  
    //   for(let i= 0 ; i<=index ; i++){
    //     this.setState({['selectedMasterQA'+i]:{}, ['selectedReAssignAuditor'+i]:[]})
    //   }
    //   this.setState({selectedcenterName:[], selectedclientName:[],
    //     selectedprocessName:[], selectedAuditor:[], saveClicked:false,
    //     startDate:'', endDate:'', search:false, assignData:[]})
    //  }
  }
  regionNames = () => {
    const{inventory} = this.props;
    if(!_.isEmpty(inventory)){
     let regionNames = _.filter(inventory);
      return regionNames;
    }
    
  }
  centerNames = () => {
    const{selectedregionName} = this.state;
    if(!_.isEmpty(selectedregionName)){
      let centerName = selectedregionName.userCenters
      return centerName;
    }
    
  }
  clientNames = () =>{
    const{selectedcenterName} = this.state;
    let clientName=[];
    if(!_.isEmpty(selectedcenterName)){
    // _.map(selectedcenterName, (obj)=>{
    //     let x = _.filter(obj.userClients);
    //    // clientName.push(...x );
    //     this.bulkclientName=clientName
        clientName = selectedcenterName.userClients
    //}) 
    return _.uniqBy(clientName, 'inventoryClientId');
    }
  }
  processNames = () => {
    const{selectedclientName} = this.state;
    let processName=[];
    if(!_.isEmpty(selectedclientName)){
      // _.map(selectedclientName, (obj)=>{
      //     let abc = _.filter(this.bulkclientName, {'inventoryClientId':obj.inventoryClientId})
      //     _.map(abc, (z) => {
            //processName.push(...z.userProcesses)
            processName= selectedclientName.userProcesses
            processName = _.uniqBy(processName, 'inventoryProcessId');
        //  })
      //})    
    }
    return processName;
  }
  handleSelect = (e) => {
    this.setState({selectedregionName: e});
    if(!_.isEqual(this.state.selectedregionName, e)){
      this.setState({selectedcenterName:[], selectedclientName:[], selectedprocessName:[], 
        selectedAuditor:[], startDate:'', endDate:'', search:false})
    }
  }
  handleSelectCenter = (e) => {
    this.setState({selectedcenterName: e});
    if(!_.isEqual(this.state.selectedcenterName, e)){
      this.setState({selectedclientName:[], selectedprocessName:[], selectedAuditor:[], search:false})
    }
  }
  handleSelectClient = (e) => {
    this.setState({selectedclientName: e});
    if(!_.isEqual(this.state.selectedclientName, e)){
      this.setState({selectedprocessName:[], selectedAuditor:[], search:false})
    }
  }
  handleSelectProcess = (e) => {
    this.setState({selectedprocessName: e});
    const {selectedregionName, selectedcenterName, selectedclientName} = this.state;
    let region =[selectedregionName.inventoryRegionId]
    let centers = [selectedcenterName.inventoryCenterId]
    //  _.map(selectedcenterName, (cx) => { 
    //   return(cx.inventoryCenterId)
    // })
    let clients = [selectedclientName.inventoryClientId]
    // _.map(selectedclientName, (cx) => { 
    //   return(cx.inventoryClientId)
    // })    
    let process = [e.inventoryProcessId]
    // _.map(e, (cx) => { 
    //   return(cx.inventoryProcessId)
    // })     
    let obj = {
      'regions': region,
      'centers': centers,
      'clients': clients,
      'processes': process
    }
    this.props.action.SearchQANames(obj)
  }
  handleSelectAuditor = (e) => {
    this.setState({selectedAuditor: e});
    if(!_.isEqual(this.state.selectedAuditor, e)){
      this.setState({search:false})
    }
  }
  handleSelectReAssignAuditor = (e, index, id) => { 
    let assignval = _.cloneDeep(this.state.assignData)
    this.setState({['selectedReAssignAuditor'+id]: e});
    let x = _.find(assignval, {'id':id})
    let value  = _.cloneDeep(e)
    _.map(value, (obj) =>{
      obj['empName'] = obj.qaName
      obj['empId'] = obj.qaId
    })
    if(!_.isEmpty(x)){
      x["assignedAuditors"] = value
    } else {
      let obj = _.cloneDeep(this.props.searchData[index])   
      obj["assignedAuditors"] = value
      assignval.push(obj)
    }
    this.setState({assignData:assignval})
  }
  
  handleSelectMasterQA = (e, index, id) => {
    let assignval = _.cloneDeep(this.state.assignData)  
    this.setState({['selectedMasterQA'+id]: e});
    let x = _.find(assignval, {'id':id})
    let value  = _.cloneDeep(e)
      value['empName'] = value.qaName
      value['empId'] = value.qaId   
    if(!_.isEmpty(x)){
      x["masterAuditor"] = value
    } else {
      let obj = _.cloneDeep(this.props.searchData[index])   
      obj["masterAuditor"] = value
      assignval.push(obj)
    } 
    let data  =[];
    if(_.has(x, 'assignedAuditors') && !_.isEmpty(x.assignedAuditors)){
      let valida = _.find(x.assignedAuditors, {'qaId':e.qaId})
      if(typeof valida === undefined || _.isEmpty(valida)){
        x.assignedAuditors.push(value)
        data  = _.cloneDeep(this.state['selectedReAssignAuditor'+id])
        data.push(e)        
      } 
    } else {
        let obj = _.cloneDeep(this.props.searchData[index])   
        obj["assignedAuditors"] = []
        obj.assignedAuditors.push(value)
        data.push(e)
    }
    this.setState({['selectedReAssignAuditor'+id]:data,assignData:assignval})
  }
  handleChangeStart = (date) => {
    //date.setMinutes( date.getMinutes() + date.getTimezoneOffset() );
    this.setState({startDate: date});
  }
  handleChangeEnd = (e) => {
    //e.setMinutes( e.getMinutes() + e.getTimezoneOffset() );
    this.setState({endDate: e});
  }
  auditorNames = () => {
   let obj = this.props.QANameList
   return obj;
  }
  SearchTemplate = () => {
    this.props.action.ResetCalibration()
    const {selectedregionName, selectedcenterName, selectedclientName, selectedprocessName, selectedAuditor, startDate, endDate} = this.state;
    let region ={'regionId':selectedregionName.inventoryRegionId, 'regionName':selectedregionName.inventoryRegionName}
    let centers = [{'centerId':selectedcenterName.inventoryCenterId, 'centerName':selectedcenterName.inventoryCenterName}]
    let clients = [{'clientId':selectedclientName.inventoryClientId, 'clientName':selectedclientName.inventoryClientName}]
    let process = [{'processId':selectedprocessName.inventoryProcessId, 'processName':selectedprocessName.inventoryProcessName}]
    let auditors = [{'empId':selectedAuditor.qaId, 'empName':selectedAuditor.qaName}]
    let obj = {
      'auditors':auditors,
      'region': region,
      'center': centers,
      'client': clients,
      'process': process,
      'startDate':moment(startDate).format('YYYY-MM-DD'),
      'endDate':moment(endDate).format('YYYY-MM-DD')
    }
    this.props.action.TokenValidation()   
    this.props.action.searchCalibaration(obj)
    this.setState({search:true})
  }
  validateForm() {  
    if(this.state.selectedprocessName && !_.isEmpty(this.state.selectedprocessName)  &&
     (typeof this.state.startDate !== 'undefined')  && (typeof this.state.endDate !== 'undefined'))
      return true;
  }
  resetTemplate = () => {
    this.setState(this.getInitialState())
    let index = this.props.searchData.length  
      for(let i= 0 ; i<=index ; i++){
      this.setState({['selectedMasterQA'+i]:{}, ['selectedReAssignAuditor'+i]:[]})
    }
  }
  handleSelectPagination = (eventKey) => {
    this.setState({
      activePage: eventKey,
    });
	}
	handleSelectPaginationPrev = () => {
		const {activePage} = this.state;
		this.setState({
      activePage: activePage-1,
    });
	}
	handleSelectPaginationNext = () => {
		const {activePage} = this.state;
		this.setState({
      activePage: activePage+1,
    });
  }
  handleChange = (e) => {
    const {filterRows} = this.state
    let filterCol = filterRows
    if(_.has(filterCol, e.target.id)){
      filterCol[e.target.id]  = e.target.value
    } else {
      filterCol = Object.assign(filterCol, {[e.target.id]:e.target.value})
    }
    this.setState({[e.target.id]:e.target.value, filterRows:filterCol})	
  }
  
  renderInboxValues = (data, startOffset, startCount, Per_Page, filterfield) => {
    const {filterRows, showFilter}  = this.state;
    let returnObj=[]
    let val =[], val1 = [];
    if(!_.isEmpty(data) && typeof data !== "undefined"){
      _.map(data.filter(searchingFor(filterRows)), (obj, index) =>{      
        if(index >= startOffset & startCount < Per_Page){
          startCount++;   
          if(!_.isEmpty(obj.assignedAuditors)){
            if(!_.isEmpty(obj.assignedAuditors[0].qaName)){
               val.push(obj.assignedAuditors[0])
            }
          }
          if(!_.isEmpty(obj.masterAuditor)){
            if(!_.isEmpty(obj.masterAuditor.qaName)){
               val1=obj.masterAuditor
            }
          }
       
      
        returnObj.push(
        <tr>
          <td>{obj.agentName}</td>
          <td>{obj.region.regionName}</td>            
          <td>{obj.center.centerName}</td>
          <td>{obj.client.clientName}</td>
          <td>{obj.process.processName}</td>           
          <td>{obj.phoneNo}</td>
          <td>{obj.date}</td>
          <td style={{width:'15%'}}>
            <Picky keepOpen={false}
            value={(this.state['selectedReAssignAuditor'+obj.id]) ? this.state['selectedReAssignAuditor'+obj.id] : val}
            options={this.auditorNames()}
            onChange={(e)=>this.handleSelectReAssignAuditor(e, index, obj.id)}
            open={false}
            valueKey="qaName"
            labelKey="qaName"
            multiple={true}
            includeSelectAll={true}
            includeFilter={true}
            clearFilterOnClose={true}
            placeholder='Select QA'
            numberDisplayed='1'
            dropdownHeight={600}
            />
              </td>
          <td style={{width:'15%'}}>  
            <Picky keepOpen={false}
            value={!_.isEmpty(this.state['selectedMasterQA'+obj.id]) ? this.state['selectedMasterQA'+obj.id] : val1}
            options={this.auditorNames()}
            onChange={(e) =>this.handleSelectMasterQA(e, index, obj.id)}
            open={false}
            valueKey="qaName"
            labelKey="qaName"
            multiple={false}
            includeSelectAll={false}
            includeFilter={true}
            clearFilterOnClose={true}
            placeholder='Select MasterQA'
            dropdownHeight={600}
            />
          </td>  
          <td><span className={_.isEmpty(this.state['selectedMasterQA'+obj.id]) ? 'GreyColor disabled': 'blackColor'}><i className="fas fa-save" 
          
          onClick={()=>this.handleSave(obj.id)}></i></span></td>
        </tr>)
                        
        }  
      })
      if(showFilter === true){
        returnObj.unshift(filterfield)
      }
    }

    else {
      returnObj=(<tr><td colSpan="10">No Record Found</td></tr>) 
    }
     return returnObj
  }
  handleSave = (id) => {
    let data = _.filter(this.state.assignData, {'id':id})
    //this.setState({saveClicked:true})
    this.props.action.TokenValidation()   
    
    const {selectedregionName, selectedcenterName, selectedclientName, selectedprocessName, selectedAuditor, startDate, endDate} = this.state;
    let region ={'regionId':selectedregionName.inventoryRegionId, 'regionName':selectedregionName.inventoryRegionName}
    let centers = [{'centerId':selectedcenterName.inventoryCenterId, 'centerName':selectedcenterName.inventoryCenterName}]
    let clients = [{'clientId':selectedclientName.inventoryClientId, 'clientName':selectedclientName.inventoryClientName}]
    let process = [{'processId':selectedprocessName.inventoryProcessId, 'processName':selectedprocessName.inventoryProcessName}]
    let auditors = [{'empId':selectedAuditor.qaId, 'empName':selectedAuditor.qaName}]
    let obj = {
      'auditors':auditors,
      'region': region,
      'center': centers,
      'client': clients,
      'process': process,
      'startDate':moment(startDate).format('YYYY-MM-DD'),
      'endDate':moment(endDate).format('YYYY-MM-DD')
    }    
    this.props.action.AssignCalibaration(data, obj)
  
  } 
  handleFilter = () =>{
    this.setState((prevState) =>{
      return {showFilter: !prevState.showFilter};
    })
    if(!_.isNull(this.state.filterRows)){
      let keys = _.keys(this.state.filterRows)
      _.map(keys, (obj) =>{
        this.setState({[obj]:""})
      })
      this.setState({filterRows:{}})
    }

  }
  
  render(){
    const{search, activePage} = this.state;
    const Per_Page=50;    
    let totalPages;
    if(!_.isEmpty(this.props.searchData)){
      totalPages =Math.ceil(this.props.searchData.length/Per_Page)
    }
    
		const startOffset = (this.state.activePage-1) * Per_Page;
		let startCount = 0;
    let items = [];
    let filterfield =[];
		for (let number = 1; number <= totalPages; number++) {
			items.push(
				<Pagination.Item key={number} active={number === activePage} onClick={()=>this.handleSelectPagination(number)}>
					{number}
				</Pagination.Item>				
			);
    }
    filterfield.push(<tr>
      <td><FormControl
      placeholder="Search"
      aria-label="Search"
      aria-describedby="basic-addon1"
      id={'agentName'}
      onChange={(e) => this.handleChange(e)}
      value={this.state.agentName}
      /></td>
      <td><FormControl
      placeholder="Search"
      aria-label="Search"
      aria-describedby="basic-addon1"
      id={'region.regionName'}
      onChange={(e) => this.handleChange(e)}
      value={this.state['region.regionName']}
        /></td>
      <td><FormControl
        placeholder="Search"
        aria-label="Search"
        aria-describedby="basic-addon1"
        id={'center.centerName'}
        onChange={(e) => this.handleChange(e)}
        value={this.state['center.centerName']}
          /></td>
      <td><FormControl
      placeholder="Search"
      aria-label="Search"
      aria-describedby="basic-addon1"
      id={'client.clientName'}
      onChange={(e) => this.handleChange(e)}
      value={this.state['client.clientName']}
        /></td>
      <td><FormControl
        placeholder="Search"
        aria-label="Search"
        aria-describedby="basic-addon1"
        id={'process.processName'}
        onChange={(e) => this.handleChange(e)}
        value={this.state['process.processName']}
          /></td>
      <td><FormControl
        placeholder="Search"
        aria-label="Search"
        aria-describedby="basic-addon1"
        id={'phoneNo'}
        onChange={(e) => this.handleChange(e)}
        value={this.state.phoneNo}
            /></td>
      <td><FormControl
        placeholder="Search"
        aria-label="Search"
        aria-describedby="basic-addon1"
        id={'date'}
        onChange={(e) => this.handleChange(e)}
        value={this.state.date}
        /></td><td/><td></td></tr>) 
    return(
      <div className='margingap'>      
      <Row>
        <Col>
          <label>Region Name</label>
        </Col>
        <Col>
        <Picky keepOpen={false}
          value={this.state.selectedregionName}
          options={this.regionNames()}
          onChange={this.handleSelect}
          open={false}
          valueKey="inventoryRegionName"
          labelKey="inventoryRegionName"
          multiple={false}
          includeSelectAll={false}
          includeFilter={true}
          clearFilterOnClose={true}
          placeholder='Select Region'
          dropdownHeight={600}
        />
        </Col>
      </Row> 
      <Row>
        <Col>
          <label>Center Name</label>
        </Col>
        <Col>
        <Picky keepOpen={false}
          value={this.state.selectedcenterName}
          options={this.centerNames()}
          onChange={this.handleSelectCenter}
          open={false}
          valueKey="inventoryCenterName"
          labelKey="inventoryCenterName"
          multiple={false}
          includeSelectAll={true}
          includeFilter={true}
          clearFilterOnClose={true}
          placeholder='Select Center'
          dropdownHeight={600}
        />
        </Col>             
      </Row>
      <Row>
       <Col>
        <label>Client Name</label>
      </Col>
      <Col>
      <Picky keepOpen={false}
        value={this.state.selectedclientName}
        options={this.clientNames()}
        onChange={this.handleSelectClient}
        open={false}
        valueKey="inventoryClientName"
        labelKey="inventoryClientName"
        multiple={false}
        includeSelectAll={true}
        includeFilter={true}
        clearFilterOnClose={true}
        placeholder='Select Client'
        dropdownHeight={600}
      />
      </Col>
      </Row> 
      <Row>
      <Col>
      <label>Process Name *</label>
      </Col>
      <Col>
      <Picky keepOpen={false}
        value={this.state.selectedprocessName}
        options={this.processNames()}
        onChange={this.handleSelectProcess}
        open={false}
        valueKey="inventoryProcessName"
        labelKey="inventoryProcessName"
        multiple={false}
        includeSelectAll={true}
        includeFilter={true}
        clearFilterOnClose={true}
        placeholder='Select Process Name'
        dropdownHeight={600}
      />
       </Col>
       </Row> 
      <Row>
        <Col>
        <label>QA Name</label>
        </Col>
        <Col>
         <Picky keepOpen={false}
          value={this.state.selectedAuditor}
          options={this.auditorNames()}
          onChange={this.handleSelectAuditor}
          open={false}
          valueKey="qaName"
          labelKey="qaName"
          multiple={false}
          includeSelectAll={false}
          includeFilter={true}
          clearFilterOnClose={true}
          placeholder='Select QA'
          dropdownHeight={600}
        />
        </Col>
       </Row>
      <Row>
        <Col>
        <label>Date Range *</label>
        </Col>
        <Col className='myContainter'>
        {/* <Row className='dateRange'> */}
            <DatePicker
            selected={this.state.startDate}
            className='myDatePicker'
            selectsStart
            showMonthDropdown
            startDate={this.state.startDate}
            endDate={this.state.endDate}
            onChange={this.handleChangeStart}
            />
            <DatePicker
            selected={this.state.endDate}
            selectsEnd
            startDate={this.state.startDate}
            endDate={this.state.endDate}
            onChange={this.handleChangeEnd}
            minDate={this.state.startDate}
            maxDate={new Date()}
            />
          {/* <Col>
          <DatePicker selected={this.state.minDate} onChange={this.handleDate} />
          <input type='date' onChange={this.handleDate} value={this.state.minDate}/> 
          
          </Col>
          <Col> 
          <DatePicker value={this.state.maxDate} onChange={this.handleDateMax} />
          {/* <input type='date' min={this.state.minDate } onChange={this.handleDateMax} 
              value={this.state.maxDate}/> */}
          
          {/* </Col> */}
          {/* </Row> */}      
         </Col> 
       </Row>
      <br/>
        <center><Button onClick={this.SearchTemplate} className='buttonwidth'  disabled={!this.validateForm()}>Search</Button> &nbsp;
       <Button className='buttonwidth' onClick={this.resetTemplate} >Reset</Button>
        </center>
        {((search)) ?  
        <p className='calibration'>
        {/* <Button className='accord buttonwidth' onClick={this.handleSave}>Assign</Button>  */}
        <Table responsive>
          <thead>
            <th> <i class="fas fa-filter alignLeft" onClick={this.handleFilter}></i>AGENT NAME</th>      
            <th>REGION</th>
            <th>CENTER</th>
            <th>CLIENT</th>
            <th>PROCESS</th>
            <th>MOBILE NO.</th>
            <th>DATE</th>
            <th>SELECT QA</th>
            <th>MASTER QA</th>
            <th>ASSIGN</th>
          </thead>
          <tbody>
            { this.renderInboxValues(_.cloneDeep(this.props.searchData), startOffset, startCount, Per_Page, filterfield)}          
          </tbody>
        </Table>
        <Pagination>
				<Pagination.First  disabled={activePage === 1} onClick={()=>this.handleSelectPagination(1)} />
				<Pagination.Prev   disabled={activePage === 1} onClick={this.handleSelectPaginationPrev} />
            {items[activePage-1]}
            {items[activePage] ? items[activePage] : (activePage !== 1) ? items[0] : null}
            {items[activePage+1]}
				<Pagination.Next disabled={activePage === totalPages} onClick={this.handleSelectPaginationNext}/>
				<Pagination.Last disabled={activePage === totalPages} onClick={()=>this.handleSelectPagination(totalPages)}/>			
				</Pagination>
       
       </p>: null}      
  </div>)
      
  }
}    


